import FeatherIconsContainer from "../../../Components/Icon/FeatherIcons/FeatherIconsContainer";

const FeatherIcon = () => {
  return <FeatherIconsContainer />;
};

export default FeatherIcon;
